/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ExhibitionWithRelations } from '../../models/exhibition-with-relations';

export interface EditorGetExhibitions$Params {
}

export function editorGetExhibitions(http: HttpClient, rootUrl: string, params?: EditorGetExhibitions$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ExhibitionWithRelations>>> {
  const rb = new RequestBuilder(rootUrl, editorGetExhibitions.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ExhibitionWithRelations>>;
    })
  );
}

editorGetExhibitions.PATH = '/editor/exhibitions';
